/**
 * --------------------------------------------------------------------------
 * Click to print
 * Function triggers default machine Print functionality on click
 * --------------------------------------------------------------------------
 */

function clickToPrint() {
	const printButtons = document.querySelectorAll(
		'.c-btn--print, a[href="#print-to-pdf"]'
	);
	if (printButtons.length) {
		printButtons.forEach((printButton) => {
			printButton.addEventListener('click', function (e) {
				e.preventDefault();
				if (
					!e.target.offsetParent.classList.contains('eight29-posts')
				) {
					window.print();
				}
			});
		});
	}
}

export default clickToPrint;
